import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useEffect, useState } from 'react';
import Menu from '../components/menu/Menu';
import ScheduledAuctionFilter from './components/ScheduledAuctionFilter';
import { FilterType, Region } from '../search/FilterData';
import { SortOption } from '../components/list/data';
import Select, { SingleValue } from 'react-select';
import List from './components/List';
import { ExpectedDataProps } from './data';
import ExpectItemService from '../../service/expect/expect';
import { isLogin } from '../../utils/auth';
import Pagination from '../components/pagination/Pagination';
import Footer from '../components/footer/Footer';
import { useModal } from '../../context/ModalContext';

const SortOptions: SortOption[] = [
  {
    value: 'CD',
    label: '사건번호 높은순',
  },
  {
    value: 'CA',
    label: '사건번호 낮은순',
  },
  {
    value: 'VD',
    label: '조회수 높은순',
  },
  {
    value: 'VA',
    label: '조회수 낮은순',
  },
  {
    value: 'BD',
    label: '청구금액 높은순',
  },
  {
    value: 'BA',
    label: '청구금액 낮은순',
  },
  {
    value: 'DA',
    label: '배당요구종기일 빠른순',
  },
  {
    value: 'DD',
    label: '배당요구종기일 늦은순',
  },
];

function ScheduledAuction() {
  const { modalDispatch } = useModal();

  const [openMenu, setOpenMenu] = useState(false);
  const [sort, setSort] = useState<SortOption>({
    value: 'CD',
    label: '사건번호 높은순',
  });
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<ExpectedDataProps[]>([]);
  const [loading, setLoading] = useState(true);
  const limit = 10;

  const [filters, setFilters] = useState<FilterType>({
    type: 'a',
    regionOrCourt: 'r',
    region: [] as Region[],
    court: '',
    belong: '',
    year: '',
    caseNumber: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidStatus: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
    holder: '',
    debtor: '',
    creditor: '',
  });

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };

  const getList = async () => {
    const renderCaseNumber = () => {
      if (filters.type === 'a') {
        if (filters.year || filters.caseNumber) {
          return filters.year + '타경' + filters.caseNumber;
        } else {
          return '';
        }
      } else {
        if (filters.caseNumber) return filters.caseNumber;
        return '';
      }
    };
    try {
      if (!isLogin()) return;
      const res = await ExpectItemService.list(
        filters.court,
        filters.belong ? `경매 ${filters.belong}` : '',
        renderCaseNumber(),
        filters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        '',
        '',
        filters.holder ?? '',
        filters.debtor ?? '',
        filters.creditor ?? '',
        sort.value,
        limit,
        0,
      );
      setData(res.data.list);
      setTotalCount(res.data.count.total_count);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getList();
  }, [sort]);

  const handleSearch = () => {
    if (!isLogin()) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      return;
    }
    getList();
  };

  return (
    <Container>
      <PageTop text="예정물건 검색" setOpenMenu={setOpenMenu} />
      <Content>
        <FilterContainer>
          <ScheduledAuctionFilter
            filters={filters}
            setFilters={setFilters}
            handleSearch={handleSearch}
          />
        </FilterContainer>

        {!isLogin() ? (
          <div
            style={{
              textAlign: 'center',
              fontSize: '13px',
              color: '#616161',
              fontWeight: '500',
              padding: '20px',
              paddingBottom: '60px',
            }}
          >
            로그인 후 이용이 가능합니다.
          </div>
        ) : (
          <>
            <ListTop>
              <div>총 {Number(totalCount).toLocaleString()}개</div>
              <Select<SortOption>
                options={SortOptions}
                styles={{
                  ...customStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                placeholder="선택"
                value={sort}
                onChange={(selectedOption: SingleValue<SortOption>) => {
                  if (selectedOption) {
                    setSort(selectedOption);
                  }
                }}
              />
            </ListTop>
            <List data={data} loading={loading} />
            {!loading && (
              <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(totalCount / limit)}
                onPageChange={(page) => {
                  setCurrentPage(page);
                }}
                removeMargin
              />
            )}
          </>
        )}
      </Content>
      <Footer />
      {openMenu && <Menu page="mypage" setOpenMenu={setOpenMenu} />}
    </Container>
  );
}

export default ScheduledAuction;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  font-family: Spoqa Han Sans Neo;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 72px;
`;

const FilterContainer = styled.div`
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 24px;
  padding-left: 16px;
`;

const ListTop = styled.div`
  width: 100%;
  height: 52px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f8f9;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  color: #616161;
`;
